// let bypassPopup = false;
// document.addEventListener("DOMContentLoaded", function() {
//   document.addEventListener('click', function (e) {
//       const btn = e.target.closest('.product-atc, .product__sticky__bar-add-cart'); 
//     if (!btn) return;
//     e.preventDefault();       
//     console.log('test');
//     // --- Show loader on button ---
//     btn.classList.add('loading');

//     const purchaseOption = document.querySelector('input[name="purchase-option"]:checked')?.value;
//     if (purchaseOption === "onetime" && !bypassPopup) {
//       console.log("One-time selected → showing popup");

//       const popup = document.getElementById("onetime-popup");
//       popup.classList.remove("hidden");
//       document.getElementById("popup-overlay").classList.remove("hidden");
//       btn.classList.remove("disable", "loading");
//       btn.disabled = false;
//       return; // stop normal ATC flow
//     }

//     // Get variant ID
//     const quantityInput = document.querySelector('.quantity__input');
//     const qty = parseInt(quantityInput.value, 10) || 1;
//     const productInput = document.querySelector('.product-input');
//     const variantId = productInput ? productInput.value : null;
//     if (!variantId) {
//       console.error('No variant ID found.');
//       return;
//     }
  
//     // Check which purchase option is selected
//     const selectedPurchaseOption = document.querySelector('input[name="purchase-option"]:checked');
//     let sellingPlanId = null;

//     if (selectedPurchaseOption) {
//       if (selectedPurchaseOption.value === 'subscription') {
//         // Only get selling plan if subscription is selected
//         const subscriptionSelect = document.querySelector('#global-subscription-plan');
//         if (subscriptionSelect) {
//           sellingPlanId = subscriptionSelect.value;
//         }
//       }
//     }

  
//     // Prepare data
//     const formData = {
//       items: [
//         {
//           id: variantId,
//           quantity: qty,
//           ...(sellingPlanId && { selling_plan: sellingPlanId }) // Only add if selected
//         }
//       ]
//     };

//     // Shopify AJAX API
//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(formData)
//     })
//       .then(res => res.json())
//       .then(data => {
//         console.log('Added to cart:', data);
//         if (window.openSidecart) {
//           window.openSidecart();
//           if (window.fetchCart) window.fetchCart();
//         }
//       })
//       .catch(err => {
//         console.error('Error adding to cart:', err);
//       })
//       .finally(() => {
//         // --- Hide loader ---
//         btn.classList.remove('loading');
//         bypassPopup = false;
//       });
//   });
//   const subBtn = document.getElementById("continue-subscription");
//   const onetimeBtn = document.getElementById("continue-onetime");

//   subBtn.addEventListener("click", function () {
//     const subRadio = document.querySelector('input[name="purchase-option"][value="subscription"]');
//     if (subRadio) subRadio.checked = true;

//     document.getElementById("onetime-popup").classList.add("hidden");
//     document.getElementById("popup-overlay").classList.add("hidden");
//     bypassPopup = true;

//     document.querySelector('.product-atc, .product__sticky__bar-add-cart').click();
//   });

//   onetimeBtn.addEventListener("click", function () {
//     document.getElementById("onetime-popup").classList.add("hidden");
//     document.getElementById("popup-overlay").classList.add("hidden");
//     bypassPopup = true;

//     document.querySelector('.product-atc, .product__sticky__bar-add-cart').click();
//   });

//     const popupClose = document.querySelector('.popup-close');
//   popupClose?.addEventListener('click', function () {
//     document.querySelector('.subscription-popup-outer').classList.add('hidden');
//     document.getElementById("popup-overlay").classList.add("hidden");

//     bypassPopup = true;
//     clickATC();
//   });
// });



// function clickATC() {
//   const mainBtn = document.querySelector('.product-atc');
//   const stickyBtn = document.querySelector('.product__sticky__bar-add-cart');

//   if (mainBtn) {
//     mainBtn.click();
//   } else if (stickyBtn) {
//     stickyBtn.click();
//   } else {
//     console.warn("No ATC buttons found.");
//   }
// }
document.addEventListener('click', function (e) {
    const btn = e.target.closest('.product-atc, .product__sticky__bar-add-cart'); 
  if (!btn) return;
  e.preventDefault();       
  console.log('test');
   // --- Show loader on button ---
  btn.classList.add('loading');
  // Get variant ID
   const quantityInput = document.querySelector('.quantity__input');
   const qty = parseInt(quantityInput.value, 10) || 1;
  const productInput = document.querySelector('.product-input');
  const variantId = productInput ? productInput.value : null;
  if (!variantId) {
    console.error('No variant ID found.');
    return;
  }
 
   // Check which purchase option is selected
  const selectedPurchaseOption = document.querySelector('input[name="purchase-option"]:checked');
  let sellingPlanId = null;

  if (selectedPurchaseOption) {
    if (selectedPurchaseOption.value === 'subscription') {
      // Only get selling plan if subscription is selected
      const subscriptionSelect = document.querySelector('#global-subscription-plan');
      if (subscriptionSelect) {
        sellingPlanId = subscriptionSelect.value;
      }
    }
  }

 
  // Pre-order products (custom.preorder_enabled) carry the ship date as a visible line
  // property so it shows in the cart drawer, checkout and on the order (CNV-7481).
  const preorderMessage = btn.dataset.preorderMessage;

  // Prepare data
  const formData = {
    items: [
      {
        id: variantId,
        quantity: qty,
        ...(sellingPlanId && { selling_plan: sellingPlanId }), // Only add if selected
        ...(preorderMessage && { properties: { 'Pre-order': preorderMessage } })
      }
    ]
  };

  // Shopify AJAX API
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
    .then(res => res.json())
    .then(data => {
      console.log('Added to cart:', data);
      if (window.openSidecart) {
        window.openSidecart();
        if (window.fetchCart) window.fetchCart();
      }
    })
    .catch(err => {
      console.error('Error adding to cart:', err);
    })
     .finally(() => {
      // --- Hide loader ---
      btn.classList.remove('loading');
    });
});
// Price update functions code start here


document.addEventListener('DOMContentLoaded', function () {
  const subRadio = document.querySelector('#radio-sub');
  const oneTimeRadio = document.querySelector('#radio-onetime');
  const subPriceEl = document.querySelector('.subscription-original-price');
  const subDiscountEl = document.querySelector('.subscription-discount-price');
  const oneTimePriceEl = document.querySelector('.one-time-discount-price');
  const quantityInput = document.querySelector('.quantity__input');
  const totalPriceEls = document.querySelectorAll('.product-total-price'); // main + sticky buttons

  function parsePrice(str) {
    return parseFloat(str.replace(/[^0-9.]/g, '')) || 0;
  }

  function setTotalPrice(value) {
    totalPriceEls.forEach(el => {
      el.textContent = `$${value}`;
    });
  }
let lastOneTimeDiscount = 0;

  // Calculate one-time total (always run)
  function calculateOneTimeTotal(qty) {
      const basePrice = parsePrice(oneTimePriceEl.dataset.onetimePrice);
      const productTags = oneTimePriceEl.dataset.productTags || '';
      const hasMoziNewPrice = productTags.includes('mozi-new-price');

      let totalDiscount = 0;
      let discountedTotal = 0;

      const originalTotal = basePrice * qty;

      // --- Default discount logic ---
      if (qty === 2) {
          totalDiscount = 8;
          discountedTotal = originalTotal - totalDiscount;
      } 
      else if (qty === 3) {
          totalDiscount = 19.20;
          discountedTotal = originalTotal - totalDiscount;
      } 
      else if (qty >= 4) {
          // Apply fixed price per item instead of flat discount
          const discountedUnitPrice = 31.99;
          discountedTotal = qty * discountedUnitPrice;

          // Calculate actual discount for tracking
          totalDiscount = originalTotal - discountedTotal;
      } 
      else {
          // qty = 1 (no discount)
          discountedTotal = originalTotal;
          totalDiscount = 0;
      }

      // SAVE one-time discount globally
      lastOneTimeDiscount = totalDiscount;

      // Update one-time price in UI
      oneTimePriceEl.textContent = `$${discountedTotal.toFixed(2)}`;

      return discountedTotal;
  }

  // Calculate subscription total (always run)
function calculateSubscriptionTotal(qty) {
    const basePrice = parsePrice(subPriceEl.dataset.originalPrice);
    const discountedUnitPrice = parsePrice(subDiscountEl.dataset.discountedPrice);
    const productTags = subDiscountEl.dataset.productTags || '';
    const hasMoziNewPrice = productTags.includes('mozi-new-price');
    // const subpopupdiscount = document.querySelector('.sub-discount');

    let discountPercent = 0;
    if (qty === 1) discountPercent = 14;
    else if (qty === 2) discountPercent = 25;
    else if (qty === 3) discountPercent = 28;
    else if (qty >= 4) discountPercent = 30;
    // else if (qty === 5) discountPercent = 22.30;
    // else if (qty >= 6) discountPercent = 23.34;

    const originalTotal = basePrice * qty;

    const discountedTotalBefore = discountedUnitPrice * qty;
    const totalDiscount = discountedTotalBefore * (discountPercent / 100);

    const discountedTotal = discountedTotalBefore - totalDiscount;

    subPriceEl.textContent = `$${originalTotal.toFixed(2)}`;
    subDiscountEl.textContent = `$${discountedTotal.toFixed(2)}`;

    // One-time discount (using same formula)
    let oneTimeDiscount = 0;
    if (qty === 2) oneTimeDiscount = 8;
    else if (qty === 3) oneTimeDiscount = 19.20;
    else if (qty >= 4) oneTimeDiscount = 31.99;
    // else if (qty === 5) oneTimeDiscount = 25;
    // else if (qty >= 6) oneTimeDiscount = qty * 5.83;

    // Popup: one-time discount minus subscription discount
    const popupValue = oneTimeDiscount - totalDiscount;

    // subpopupdiscount.textContent = `$${Math.abs(popupValue).toFixed(2)}`;

    return discountedTotal;
}



 

  function updateTotal() {
    const qty = parseInt(quantityInput.value, 10) || 1;

    // Always recalc both prices
    const subscriptionTotal = calculateSubscriptionTotal(qty);
    const oneTimeTotal = calculateOneTimeTotal(qty);

    // But update Add to Cart total only for active selection
    if (subRadio.checked) {
      setTotalPrice(subscriptionTotal.toFixed(2));
    } else if (oneTimeRadio.checked) {
      setTotalPrice(oneTimeTotal.toFixed(2));
    }
  }

  // Listeners
  subRadio.addEventListener('change', updateTotal);
  oneTimeRadio.addEventListener('change', updateTotal);
  quantityInput.addEventListener('input', updateTotal);

  document.querySelectorAll('.quantity__button').forEach(btn => {
    btn.addEventListener('click', () => {
      setTimeout(updateTotal, 50);
    });
  });

  // Initial
  updateTotal();
});




// Price update functions code end here
// Update quantity code in stickybar start  here and vice versa
document.addEventListener("DOMContentLoaded", function() {
  const mainQtyInput = document.querySelector(".product-form__quantity .quantity__input");
  const stickyQtyInput = document.querySelector(".product__sticky__bar-quantity .quantity__input");

  console.log("Main qty input:", mainQtyInput);
  console.log("Sticky qty input:", stickyQtyInput);

  if (mainQtyInput && stickyQtyInput) {
    // --- Sync on page load ---
    stickyQtyInput.value = mainQtyInput.value;

    // --- When main quantity changes → update sticky bar ---
    mainQtyInput.addEventListener("input", syncMainToSticky);
    mainQtyInput.addEventListener("change", syncMainToSticky);

    // --- When sticky quantity changes → update main ---
    stickyQtyInput.addEventListener("input", syncStickyToMain);
    stickyQtyInput.addEventListener("change", syncStickyToMain);

    function syncMainToSticky() {
      stickyQtyInput.value = mainQtyInput.value;
    }

    function syncStickyToMain() {
      mainQtyInput.value = stickyQtyInput.value;
    }

    // --- EXTRA: Ensure plus/minus buttons trigger sync ---
    const observer = new MutationObserver(() => {
      stickyQtyInput.value = mainQtyInput.value;
    });
    observer.observe(mainQtyInput, { attributes: true, attributeFilter: ['value'] });
  }
});


// Update quantity code in stickybar end  here and vice versa

// Subscription sorting code start here
// document.addEventListener('DOMContentLoaded', function () {
//   const select = document.getElementById('global-subscription-plan');
//   const options = Array.from(select.options);

//   // Define your desired order exactly as it appears in the text
//   const order = [
//     "Delivered every 4 weeks",
//     "Delivered every 6 weeks",
//     "Delivered every 2 months",
//     "Delivered every 3 months",
//     "Delivered every 4 months"
//   ];

//   options.sort((a, b) => {
//     const indexA = order.indexOf(a.textContent.trim());
//     const indexB = order.indexOf(b.textContent.trim());

//     // If an option is not in the order array, put it at the end
//     return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
//   });

//   // Remove existing options and append the sorted ones
//   select.innerHTML = '';
//   options.forEach(opt => select.appendChild(opt));
// });
// Subscription sorting code end here




// Price update for addons code start here



document.addEventListener('DOMContentLoaded', function () {
  // Grab main product block inside .non-subscription
  const mainWrapper = document.querySelector('.non-subscription');
  const mainQty = mainWrapper ? mainWrapper.querySelector('.quantity__input') : null;
  const plusMain = mainWrapper ? mainWrapper.querySelector('button[name="plus"]') : null;
  const minusMain = mainWrapper ? mainWrapper.querySelector('button[name="minus"]') : null;

  // Grab sticky bar quantity input
  const stickyWrapper = document.querySelector('.product__sticky-bar');
  const stickyQty = stickyWrapper ? stickyWrapper.querySelector('.quantity__input') : null;
  const plusSticky = stickyWrapper ? stickyWrapper.querySelector('button[name="plus"]') : null;
  const minusSticky = stickyWrapper ? stickyWrapper.querySelector('button[name="minus"]') : null;

  // Get base price from main plus button or set to 0
  const basePrice = plusMain && plusMain.dataset.price
    ? parseFloat(plusMain.dataset.price.replace(/[^\d.]/g, '')) || 0
    : 0;

  function clampQty(v) { return Math.max(1, parseInt(v, 10) || 1); }

  function syncQtyAndPrice(fromInput) {
    const qty = clampQty(fromInput.value);

    // Sync both inputs
    if (mainQty && mainQty !== fromInput) mainQty.value = qty;
    if (stickyQty && stickyQty !== fromInput) stickyQty.value = qty;

    // Update all price displays
    const total = (basePrice * qty).toFixed(2);
    document.querySelectorAll('.product-total-price').forEach(el => {
      el.textContent = `$${total}`;
    });
  }

  // Listen for manual input
  if (mainQty) {
    mainQty.addEventListener('input', () => syncQtyAndPrice(mainQty));
    mainQty.addEventListener('change', () => syncQtyAndPrice(mainQty));
  }
  if (stickyQty) {
    stickyQty.addEventListener('input', () => syncQtyAndPrice(stickyQty));
    stickyQty.addEventListener('change', () => syncQtyAndPrice(stickyQty));
  }

  // Listen for plus/minus (theme updates quantity automatically)
  if (plusMain) plusMain.addEventListener('click', () => setTimeout(() => syncQtyAndPrice(mainQty), 0));
  if (minusMain) minusMain.addEventListener('click', () => setTimeout(() => syncQtyAndPrice(mainQty), 0));
  if (plusSticky) plusSticky.addEventListener('click', () => setTimeout(() => syncQtyAndPrice(stickyQty), 0));
  if (minusSticky) minusSticky.addEventListener('click', () => setTimeout(() => syncQtyAndPrice(stickyQty), 0));

  // Initialize on load
  if (mainQty) syncQtyAndPrice(mainQty);
});









// Price update for addons code end here

//Upsell addtocart code start here

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.btn-upsell').forEach(function(button) {
    button.addEventListener('click', function() {
       const btn = this;  
        // --- Show loader ---
      btn.classList.add('loading');
      const variantId = this.getAttribute('data-variant-id');

      if (!variantId) {
        console.error("No variant ID found on button.");
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log("Product added to cart:", data);
         if (window.openSidecart) {
        window.openSidecart();
        if (window.fetchCart) window.fetchCart();
         }
      })
      .catch(error => {
        console.error("Error adding to cart:", error);
        //  alert("Error adding to cart: " + error);
      })
         .finally(() => {
      // --- Hide loader ---
      btn.classList.remove('loading');
    });
    });
  });
});


//upsell addtocart code end here
